import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { createLLMAgentValidation } from "../graphql/mutations";
import {
  CreateLLMAgentValidationInput,
  CreateLLMAgentValidationMutation,
} from "../API";

export async function createValidationAfterEdit(
  values: CreateLLMAgentValidationInput
): Promise<GraphQLResult<CreateLLMAgentValidationMutation>> {
  return API.graphql(
    graphqlOperation(createLLMAgentValidation, {
      input: {
        projectId: values.projectId,
        agentId: values.agentId,
        name: values.name || "",
        description: values.description || "",
        operator: values.operator,
        expectedValue: values.expectedValue || "",
        customPromptTemplate: values.customPromptTemplate || "",
        status: values.status || "ACTIVE",
      },
    })
  ) as Promise<GraphQLResult<CreateLLMAgentValidationMutation>>;
}
